"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanonicalLanguages = exports.getPageLanguages = exports.formPageLanguages = exports.storeLangUrls = void 0;
const fdr_lib_i18n_lang_config_1 = require("@hotelplan/fdr.lib.i18n.lang-config");
function formLangUrl(meta) {
    var _a, _b;
    const url = (_b = (_a = meta === null || meta === void 0 ? void 0 : meta.webMeta) === null || _a === void 0 ? void 0 : _a.link) === null || _b === void 0 ? void 0 : _b.url;
    return url ? { uri: url } : null;
}
const storeLangUrls = (urls) => {
    return { [fdr_lib_i18n_lang_config_1.LANG_URLS_PROP]: urls };
};
exports.storeLangUrls = storeLangUrls;
function formPageLanguages(data) {
    if (!data)
        return null;
    const preResult = fdr_lib_i18n_lang_config_1.languageList.reduce((acc, lng) => {
        const meta = lng in data ? data[lng] : null;
        const urlCandidate = formLangUrl(meta);
        if (urlCandidate)
            acc.push([lng, urlCandidate]);
        return acc;
    }, []);
    if (!preResult.length)
        return null;
    return (0, exports.storeLangUrls)(Object.fromEntries(preResult));
}
exports.formPageLanguages = formPageLanguages;
function getPageLanguages(pageProps) {
    var _a;
    return (((_a = pageProps === null || pageProps === void 0 ? void 0 : pageProps.props) === null || _a === void 0 ? void 0 : _a[fdr_lib_i18n_lang_config_1.LANG_URLS_PROP]) || (pageProps === null || pageProps === void 0 ? void 0 : pageProps[fdr_lib_i18n_lang_config_1.LANG_URLS_PROP]) || null);
}
exports.getPageLanguages = getPageLanguages;
function getCanonicalLanguages(pageProps) {
    var _a;
    return (((_a = pageProps === null || pageProps === void 0 ? void 0 : pageProps.props) === null || _a === void 0 ? void 0 : _a[fdr_lib_i18n_lang_config_1.CANONICAL_URLS_PROP]) ||
        (pageProps === null || pageProps === void 0 ? void 0 : pageProps[fdr_lib_i18n_lang_config_1.CANONICAL_URLS_PROP]) ||
        null);
}
exports.getCanonicalLanguages = getCanonicalLanguages;
//# sourceMappingURL=page-props.js.map